export default {
  getItens(state) {
    return state.itensEstoque;
  },
  getTableHeaders(state) {
    return state.tableHeaders.filter((coluna) => coluna.hidden !== true);
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
  getEmpresasArmazenagem(state) {
    return state.empresasArmazenagem;
  },
};
